import type { NodeT, SkeletonConfigT, SkeletonDataT, SkeletonTemplateT } from '../../../types';
export const interpolateSkeleton = (initialSkeleton: SkeletonDataT, finalSkeleton: SkeletonDataT, interpolationFactor: number): SkeletonDataT => {
  const initialNodes = initialSkeleton.nodes;
  const finalNodes = finalSkeleton.nodes;
  const updatedNodes = initialNodes.map((node, index) => {
    const finalNode = finalNodes[index];
    // @ts-expect-error todo(ts-migration) TS18048 'finalNode' is possibly 'undefined'.
    const newX = node.point[0] + (finalNode.point[0] - node.point[0]) * interpolationFactor;
    // @ts-expect-error todo(ts-migration) TS18048 'finalNode' is possibly 'undefined'.
    const newY = node.point[1] + (finalNode.point[1] - node.point[1]) * interpolationFactor;
    return {
      ...node,
      point: ([newX, newY] as [number, number])
    };
  });
  return {
    ...initialSkeleton,
    nodes: updatedNodes
  };
};
export const generateSkeleton = ({
  centerX,
  centerY,
  template,
  stageWidth,
  stageHeight
}: {
  centerX: number;
  centerY: number;
  template: SkeletonConfigT;
  stageWidth?: number;
  stageHeight?: number;
}): SkeletonConfigT => {
  let canvasLeft = centerX - template.canvas.width / 2;
  let canvasTop = centerY - template.canvas.height / 2;

  // Clamp the skeleton to stay within stage bounds
  if (stageWidth !== undefined && stageHeight !== undefined) {
    const canvasRight = canvasLeft + template.canvas.width;
    const canvasBottom = canvasTop + template.canvas.height;

    // Adjust if skeleton goes beyond left edge
    if (canvasLeft < 0) {
      canvasLeft = 0;
    }
    // Adjust if skeleton goes beyond right edge
    if (canvasRight > stageWidth) {
      canvasLeft = stageWidth - template.canvas.width;
    }
    // Adjust if skeleton goes beyond top edge
    if (canvasTop < 0) {
      canvasTop = 0;
    }
    // Adjust if skeleton goes beyond bottom edge
    if (canvasBottom > stageHeight) {
      canvasTop = stageHeight - template.canvas.height;
    }

    // Final check: if skeleton is larger than stage, center it
    if (template.canvas.width > stageWidth) {
      canvasLeft = (stageWidth - template.canvas.width) / 2;
    }
    if (template.canvas.height > stageHeight) {
      canvasTop = (stageHeight - template.canvas.height) / 2;
    }
  }
  const nodes: NodeT[] = template.skeleton.nodes.map(nodeDef => ({
    id: nodeDef.id,
    point: ([canvasLeft + nodeDef.point[0], canvasTop + nodeDef.point[1]] as const)
  }));
  const edges = template.skeleton.edges.map(edgeDef => ({
    startNode: edgeDef.startNode,
    endNode: edgeDef.endNode
  }));
  return {
    canvas: {
      ...template.canvas
    },
    skeleton: {
      nodes,
      edges
    }
  };
};
export const fitSkeletonTemplateToBox = (template: SkeletonTemplateT, box: {
  x: number;
  y: number;
  width: number;
  height: number;
}): SkeletonDataT => {
  const getNodeLabel = (nodeId: string) => {
    return template.nodes.find(node => node.id === nodeId)?.label ?? '';
  };
  const nodes: NodeT[] = template.nodes.map(node => ({
    id: node.label,
    point: ([box.x + node.x * box.width, box.y + node.y * box.height] as [number, number]),
    ...(node.color && {
      color: node.color
    })
  }));
  const edges = template.edges.map(edge => ({
    startNode: getNodeLabel(edge.sourceNodeId),
    endNode: getNodeLabel(edge.targetNodeId)
  }));
  return {
    nodes,
    edges,
    templateId: template.id
  };
};